import { useState, useCallback } from "react";
import { AUTH_VALIDATION } from "../constants/auth";

interface UseOTPFlowResult {
  email: string;
  otpCode: string;
  showOtpInput: boolean;
  setEmail: (email: string) => void;
  setOtpCode: (code: string) => void;
  showOtpScreen: () => void;
  backToEmailScreen: () => void;
  isEmailValid: boolean;
  isOtpValid: boolean;
}

export const useOTPFlow = (): UseOTPFlowResult => {
  const [email, setEmail] = useState<string>("");
  const [otpCode, setOtpCode] = useState<string>("");
  const [showOtpInput, setShowOtpInput] = useState<boolean>(false);

  const showOtpScreen = useCallback(() => {
    setShowOtpInput(true);
  }, []);

  const backToEmailScreen = useCallback(() => {
    setShowOtpInput(false);
    setOtpCode("");
  }, []);

  const isEmailValid = AUTH_VALIDATION.EMAIL_PATTERN.test(email);
  const isOtpValid = AUTH_VALIDATION.OTP_PATTERN.test(otpCode);

  return {
    email,
    otpCode,
    showOtpInput,
    setEmail,
    setOtpCode,
    showOtpScreen,
    backToEmailScreen,
    isEmailValid,
    isOtpValid,
  };
};
